module.exports = "/lucky-balls/img/weager/Shuffle.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Shuffle.png
// module id = 1171
// module chunks = 0